import { render, staticRenderFns } from "./ForGotPasswordLayout.vue?vue&type=template&id=2b4fb429"
import script from "./ForGotPasswordLayout.vue?vue&type=script&lang=js"
export * from "./ForGotPasswordLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports